import { render, staticRenderFns } from "./board-main.vue?vue&type=template&id=23bebb1c&scoped=true&"
import script from "./board-main.vue?vue&type=script&lang=js&"
export * from "./board-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bebb1c",
  null
  
)

export default component.exports